import { render, staticRenderFns } from "./AnnotationsContainer.vue?vue&type=template&id=35d859b2&scoped=true"
import script from "./AnnotationsContainer.vue?vue&type=script&lang=js"
export * from "./AnnotationsContainer.vue?vue&type=script&lang=js"
import style0 from "./AnnotationsContainer.vue?vue&type=style&index=0&id=35d859b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d859b2",
  null
  
)

export default component.exports